import React, { Component } from "react";
// import Particles from "react-particles-js";
// import particle_config from "./particle.js";
import { geolocated } from "react-geolocated";
import "./skeleton.css";
import "./normalize.css";
import "./login.css";

const SPOTIFY_QUERY_CREATE =
  "https://accounts.spotify.com/authorize?show_dialog=true&client_id=237066dd57494b8e9842fa6dc07c8cc3&response_type=code&redirect_uri=https%3A%2F%2Fsymphony-v2.firebaseapp.com%2Fcallbackcreate&scope=user-top-read%2Cplaylist-modify-public%2Cplaylist-modify-private%2Cugc-image-upload";

const SPOTIFY_QUERY_JOIN =
  "https://accounts.spotify.com/authorize?show_dialog=true&client_id=237066dd57494b8e9842fa6dc07c8cc3&response_type=code&redirect_uri=https%3A%2F%2Fsymphony-v2.firebaseapp.com%2Fcallbackjoin&scope=user-top-read%2Cplaylist-modify-public%2Cplaylist-modify-private%2Cugc-image-upload";

class Login extends Component {
  render() {
    return !this.props.isGeolocationAvailable ? (
      <div>Your browser does not support Geolocation</div>
    ) : !this.props.isGeolocationEnabled ? (
      <div>Geolocation is not enabled</div>
    ) : (
      <div className="container">
        <div className="l-background" />
        <div className="row">
          <div className="twelve columns">
            <div className="l-title">Symphony.</div>
          </div>
        </div>
        <div className="row">
          <div className="twelve columns">
            <div className="l-description">
              Symphony is a social music platform powered by Spotify for
              creating collaborative playlists based on geolocation and friends.
              If you are a guest simply join a local gig in your area.
            </div>
          </div>
        </div>
        <div className="row">
          <div className="six columns">
            <a href={SPOTIFY_QUERY_CREATE} className="l-create-link">
              <div className="l-button">create</div>
            </a>
          </div>
          <div className="six columns">
            <a href={SPOTIFY_QUERY_JOIN} className="l-join-link">
              <div className="l-button">join</div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: true
  },
  userDecisionTimeout: 5000
})(Login);



// WEBPACK FOOTER //
// ./src/login.js